var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{staticClass:"mt-8"},[_c('v-col',{attrs:{"cols":"12","lg":"10","offset-lg":"1"}},[_c('course-list',{attrs:{"courses":_vm.courses}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }